import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@carbon/react";
import "./complete.scss";

/** The intro shown above the signup form (Carbon). "Complete the form…" + a link
 * back to login for users who already have an account. */
export default function Complete() {
  const { t } = useTranslation();
  return (
    <div className="register-complete">
      <h2 className="register-complete__title">
        {t("register.form.complete")}
      </h2>
      <p className="register-complete__text">
        {t("register.form.have")}{" "}
        <Link as={RouterLink} to="/">
          {t("register.form.login")}
        </Link>
      </p>
    </div>
  );
}
